export default __webpack_public_path__ + "static/media/587.a99e7505.gif";